import { HttpClient } from '@angular/common/http';
import { Injectable, Signal, WritableSignal, computed, signal } from '@angular/core';
import { environment } from '../../../environments/environment';
import { CurrentUser } from '../../interfaces/current-user';
import { User } from '../../user';
import { tap } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  api: string;

  currentUser: WritableSignal<CurrentUser | null> = signal(null);
  isLoggedIn!: Signal<boolean>;

  constructor(
    private http: HttpClient,
    private router: Router,
  ) {
    this.api = `${environment.api}/auth`;
    this.load();
    this.isLoggedIn = computed(() => !!this.currentUser());
   }

   load(){
    return this.currentUser.set(localStorage.getItem('current_user') ? JSON.parse(localStorage.getItem('current_user')!) : null);
   }

   login(email: string, password: string){
    return this.http.post<CurrentUser>(`${this.api}/login`, { email: email, password: password }, {observe: 'body'})
                    .pipe(tap(res=> this.setUser(res) ));
   }

   setUser(userData: CurrentUser){
      this.currentUser.set(userData);
      localStorage.setItem('current_user', JSON.stringify(userData));
   }

  validateSession(){
    return this.http.get(`${this.api}/validate`,{observe: "response"});
  }

  destroySession(){
    this.currentUser.set(null);
    localStorage.clear();
  }

  isAuthenticated(){
    return this.isLoggedIn();
  }

  getAuthToken(){
    return this.currentUser()?.token;
  }

  logout(){
    return this.http.post(`${this.api}/logout`, {}, {observe: 'body'}).subscribe({
      error: err => {
          localStorage.clear();
          this.router.navigate(['login'])
      },
      complete: () => {
        this.destroySession();
        this.router.navigate(['login']);
      }
    });
  }
}
